import clsx from 'clsx'
import { LinearGradient } from 'expo-linear-gradient'
import type { PropsWithChildren, ReactNode } from 'react'
import { View } from 'react-native'

type TIntentionCtaBlockProps = {
  isSuccess?: boolean
  className?: string
}

const commonClassName = 'w-full flex-col gap-4 overflow-hidden rounded-lg p-6'

export const IntentionCtaBlock = ({
  children,
  className,
  isSuccess,
}: PropsWithChildren<TIntentionCtaBlockProps>): ReactNode =>
  isSuccess ? (
    <View className={clsx(commonClassName, 'bg-success-bg-high', className)}>{children}</View>
  ) : (
    <LinearGradient
      start={{ x: 0.28, y: 0 }}
      locations={[0, 1]}
      colors={['#FFF0C7', '#FFE4C9']}
      className={clsx(commonClassName, className)}
    >
      {children}
    </LinearGradient>
  )
